import "./index.css";

import { useEffect, useState } from "react";


export function App() {
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch("/api/hello");
        const text = await res.text();
        setMessage(text);
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
      }
    })();
  }, []);

  return (
    <div>
      <h1>API says</h1>
      {error ? <pre>{error}</pre> : <pre>{message ?? "Loading..."}</pre>}
    </div>
  );
}

export default App;
